import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Step1 } from './step1';
import OnboardingLoading from './loading';
import Progress from './progress';

import Logo from './images/logo.jpg';

import './styles.css';

export default function Process({
  onSelectBusinessType,
  selectedBusinessType,
  onCreateDemoGame,
  gameCreated,
  existingSession,
  onStepChange,
}) {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('next');

  const handleNextStep = () => {
    if (!isAnimating) {
      // If a game session already exists, route based on progress
      if (existingSession) {
        if (existingSession.completed) {
          navigate('/instructor/onboarding/all-exercises');
        } else if (existingSession.level1 === true || existingSession.level1 === 'completed') {
          navigate('/classification/level/2?onboarding=true');
        } else {
          navigate('/classification/level/1/tutorial?onboarding=true');
        }
        return;
      }

      setAnimationDirection('next');
      setIsAnimating(true);

      setTimeout(() => {
        const nextStep = currentStep + 1;
        setCurrentStep(nextStep);
        setIsAnimating(false);
        if (onStepChange) onStepChange(nextStep);
      }, 300);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            onNext={handleNextStep}
            onSelectBusinessType={onSelectBusinessType}
            selectedBusinessType={selectedBusinessType}
          />
        );
      case 2:
        return (
          <OnboardingLoading
            onCreateDemoGame={onCreateDemoGame}
            gameCreated={gameCreated}
          />
        );
      default:
        return (
          <Step1
            onNext={handleNextStep}
            onSelectBusinessType={onSelectBusinessType}
            selectedBusinessType={selectedBusinessType}
          />
        );
    }
  };

  return (
    <div className="onboarding-process">
      <div className={`logo-wrapper${currentStep > 1 ? ' visible' : ''}`}>
        <img src={Logo} alt="Logo" className="onboarding-logo" />
        <span>Market Games</span>
      </div>

      {/* Invisible spacer matching the tournament-onboarding layout: the
          Progress block reserves the same ~85px of vertical space the
          tournament flow uses on its first page, so the welcome modal
          sits at the same y-coordinate across both onboarding paths. */}
      <Progress
        currentStep={currentStep}
        totalSteps={2}
        isVisible={false}
      />

      <div className={`step-container ${isAnimating ? `animating-${animationDirection}` : ''}`}>
        {renderStep()}
      </div>
    </div>
  )
};
